export const WAITLIST_STORAGE_KEY = "reachmenow_waitlist";

/**
 * @returns {{ joined: boolean, email: string | null }}
 */
export function readWaitlistState() {
  if (typeof window === "undefined") return { joined: false, email: null };
  try {
    const raw = localStorage.getItem(WAITLIST_STORAGE_KEY);
    if (!raw) return { joined: false, email: null };
    const p = JSON.parse(raw);
    if (!p || typeof p.joined !== "boolean") return { joined: false, email: null };
    return {
      joined: p.joined,
      email: typeof p.email === "string" ? p.email : null,
    };
  } catch {
    return { joined: false, email: null };
  }
}

/** Call after successful signup or 409 (already on list). */
export function persistWaitlistJoined(email) {
  if (typeof window === "undefined") return;
  const trimmed = typeof email === "string" ? email.trim() : "";
  localStorage.setItem(
    WAITLIST_STORAGE_KEY,
    JSON.stringify({ v: 1, joined: true, email: trimmed || null })
  );
}
